import * as React from 'react';
import RibbonButton, { RibbonButtonState } from './RibbonButton';
import RibbonPlugin from '../../plugin/RibbonPlugin';
import controlStrings from 'owa-strings/owa-common-strings';
import strings from 'owa-strings/owa-mail-strings';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { setImageAltText } from 'roosterjs-editor-api';
import { QueryScope } from 'roosterjs-editor-types';

let styles = require('./imageAltText.scss');

const imageAltText: RibbonButton = {
    key: 'imageAltText',
    title: () => strings.imageAltText,
    imageSrc: require('../svg/imagealttext.svg'),
    buttonState: formatState =>
        formatState.canAddImageAltText ? RibbonButtonState.Normal : RibbonButtonState.Disabled,
    onExecute: showImageAltTextDialogForSelection,
};

export default imageAltText;

async function showImageAltTextDialogForSelection(plugin: RibbonPlugin) {
    let editor = plugin.getEditor();
    let range = editor.getSelectionRange();
    let nodeSelectedByPlugin = await plugin.getImageSelectedByPlugin();
    let node = nodeSelectedByPlugin || editor.queryElements('img', QueryScope.OnSelection)[0];

    plugin.workaroundFocusIssueForFirefox();

    await showImageAltTextDialog(node, alt => {
        editor.select(range);
        if (nodeSelectedByPlugin) {
            nodeSelectedByPlugin.alt = alt;
        } else {
            setImageAltText(editor, alt);
        }
    });
}

export async function showImageAltTextDialog(
    node: HTMLImageElement,
    okCallBack: (alt: string) => void,
    dismissCancelCallBack?: () => void
) {
    if (node) {
        let alt = node.alt;
        let imageAltTextInput: HTMLInputElement;
        if (
            DialogResponse.ok ==
            (await confirm(strings.altTextTitle, null /*subText*/, false /*resolveImmediately*/, {
                okText: controlStrings.okButton,
                cancelText: controlStrings.cancelButton,
                bodyElement: (
                    <div>
                        <div className={styles.imagePreviewContainer}>
                            <img src={node.src} className={styles.imagePreview} />
                        </div>
                        <input
                            id="altTextInput"
                            role="textbox"
                            type="text"
                            ref={ref => (imageAltTextInput = ref)}
                            onChange={() => (alt = imageAltTextInput.value)}
                            defaultValue={alt}
                            className={styles.altTextInputLabel}
                            aria-label={strings.altTextInputLabel}
                        />
                    </div>
                ),
                delayCallbackAfterAnimation: true,
                focusSelector: '#altTextInput',
            }))
        ) {
            okCallBack(alt);
        } else if (dismissCancelCallBack) {
            dismissCancelCallBack();
        }
    }
}
